/* global axios */
import ApiClient from './ApiClient';

class ClientPortalsAPI extends ApiClient {
  constructor() {
    super('client_portals', { accountScoped: true });
  }
}

export default new ClientPortalsAPI();
